import { ErrorSource, HttpStatusCode } from "../types";

export class ErrorResponse {
  private _source: ErrorSource;
  private _message?: string;
  private _httpStatusCode?: HttpStatusCode;

  constructor(
    source: ErrorSource,
    message?: string,
    httpStatusCode?: HttpStatusCode
  ) {
    this._source = source;
    this._message = message;
    this._httpStatusCode = httpStatusCode;
  }

  get source(): ErrorSource {
    return this._source;
  }

  get message(): string | undefined {
    return this._message;
  }

  get httpStatusCode(): HttpStatusCode | undefined {
    return this._httpStatusCode;
  }
}
